import SalariesEditing from './salaries-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class SalariesUI extends Plugin {
    init() { }
}
export default class Salaries extends Plugin {
    static get requires() {
        return [SalariesEditing, SalariesUI];
    }
}
